import React, { useState, useEffect } from 'react';
import { getCountries } from '../../services/supabase/properties';

/**
 * Komponent wyboru kraju ze słownika
 */
export default function CountrySelect({ value, onChange, className = '' }) {
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadCountries();
  }, []);

  const loadCountries = async () => {
    try {
      const data = await getCountries();
      setCountries(data);
    } catch (err) {
      console.error('Error loading countries:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (error) {
    return (
      <div className="text-sm text-red-600">
        Błąd ładowania krajów: {error}
      </div>
    );
  }

  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={`w-full px-4 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all ${className}`}
      disabled={loading}
    >
      {loading ? (
        <option>Ładowanie...</option>
      ) : (
        countries.map(country => (
          <option key={country.code} value={country.code}>
            {country.name}
          </option>
        ))
      )}
    </select>
  );
}
